/* Children of Arabia theme scripts. No dependencies. Includes the hero sale countdown. */
(function () {
  'use strict';

  function safe(fn) { try { return fn(); } catch (e) { return null; } }
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  /* ---------- Country selector ---------- */
  document.querySelectorAll('[data-country-select]').forEach(function (select) {
    select.addEventListener('change', function () { select.form.submit(); });
  });

  /* ---------- Announcement bar: rotate messages, drop expired ones ---------- */
  (function announce() {
    var track = document.querySelector('[data-announce]');
    if (!track) return;
    var now = Date.now() / 1000;
    track.querySelectorAll('[data-ends]').forEach(function (m) {
      if (Number(m.getAttribute('data-ends')) <= now) m.remove();
    });
    if (!track.querySelector('[data-ends]')) track.closest('.announcement').classList.remove('announcement--promo');
    /* Live countdown inside time-limited messages. */
    track.querySelectorAll('[data-ends]').forEach(function (m) {
      var out = m.querySelector('[data-countdown]');
      if (!out) return;
      var ends = Number(m.getAttribute('data-ends'));
      function tick() {
        var left = Math.max(0, Math.floor(ends - Date.now() / 1000));
        if (!left) {
          m.remove();
          var bar = track.closest('.announcement');
          bar.classList.remove('announcement--promo');
          var first = track.firstElementChild;
          if (first) first.classList.add('is-active'); else bar.remove();
          return;
        }
        var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), min = Math.floor(left % 3600 / 60), sec = left % 60;
        out.textContent = (d ? d + 'd ' : '') + h + 'h ' + ('0' + min).slice(-2) + 'm ' + ('0' + sec).slice(-2) + 's';
      }
      tick();
      setInterval(tick, 1000);
    });

    var msgs = Array.prototype.slice.call(track.children);
    if (!msgs.length) { track.closest('.announcement').remove(); return; }
    if (!msgs.some(function (m) { return m.classList.contains('is-active'); })) msgs[0].classList.add('is-active');
    if (msgs.length < 2 || reduceMotion || track.hasAttribute('data-no-rotate')) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4500);
  })();

  /* ---------- Limited-time code: attach it to the visitor's cart so checkout already has it ---------- */
  (function autoCode() {
    var code = document.body.getAttribute('data-auto-code');
    if (!code || !window.fetch) return;
    var now = Date.now();
    if (Number(document.body.getAttribute('data-auto-code-ends')) * 1000 <= now) return;
    if (document.cookie.indexOf('discount_code=' + encodeURIComponent(code)) > -1) return;
    var key = 'coa-auto-code-' + code;
    var last = Number(safe(function () { return localStorage.getItem(key); }) || 0);
    if (now - last < 12 * 3600 * 1000) return; /* respect a swap to another code for a while */
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
      .then(function () {
        var saved = safe(function () { localStorage.setItem(key, String(now)); return true; });
        if (saved && document.body.classList.contains('template-cart')) window.location.reload();
      })
      .catch(function () {});
  })();

  /* ---------- Sale price line: hide once the code has ended ---------- */
  document.querySelectorAll('[data-sale-ends]').forEach(function (el) {
    if (Number(el.getAttribute('data-sale-ends')) <= Date.now() / 1000) {
      var wrap = el.closest('[data-sale-wrap]');
      if (wrap) wrap.classList.remove('card__price--code', 'product__price--code');
      el.remove();
    }
  });

  /* ---------- Hero sale headline: live countdown, back to normal when it ends ---------- */
  (function heroSale() {
    var sale = document.querySelector('[data-hero-sale]');
    if (!sale) return;
    var normal = document.querySelector('[data-hero-normal]');
    var out = sale.querySelector('[data-countdown]');
    var ends = Number(sale.getAttribute('data-ends'));
    function end() { sale.remove(); if (normal) normal.hidden = false; }
    function tick() {
      var left = Math.max(0, Math.floor(ends - Date.now() / 1000));
      if (!left) { end(); return false; }
      if (out) {
        var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), min = Math.floor(left % 3600 / 60), sec = left % 60;
        out.textContent = (d ? d + 'd ' : '') + h + 'h ' + ('0' + min).slice(-2) + 'm ' + ('0' + sec).slice(-2) + 's';
      }
      return true;
    }
    if (tick()) { var timer = setInterval(function () { if (!tick()) clearInterval(timer); }, 1000); }
  })();

  /* ---------- Cart count ---------- */
  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
      node.hidden = !count;
    });
  }

  /* ---------- Welcome reward: subscribe to unlock the code ---------- */
  (function reward() {
    var tab = document.querySelector('[data-reward-tab]');
    var modal = document.querySelector('[data-reward-modal]');
    if (!tab || !modal) return;
    var join = modal.querySelector('[data-reward-join]');
    var done = modal.querySelector('[data-reward-done]');
    var KEY = 'coa-reward-dismissed';
    var SUB = 'coa-subscribed';

    var fromReward = window.location.hash === '#RewardForm';
    var posted = /[?&]customer_posted=true/.test(window.location.search);
    if (fromReward && posted) safe(function () { localStorage.setItem(SUB, '1'); });
    var subscribed = safe(function () { return localStorage.getItem(SUB); });
    var dismissed = safe(function () { return sessionStorage.getItem(KEY); });

    function showStep(isDone) { join.hidden = !!isDone; done.hidden = !isDone; }
    function remember() { safe(function () { sessionStorage.setItem(KEY, '1'); }); }
    function openModal() { showStep(subscribed); modal.hidden = false; tab.hidden = true; }
    function closeModal() { modal.hidden = true; tab.hidden = true; remember(); }

    if (fromReward) {
      /* Back from submitting: show the code, or the form with its error. */
      openModal();
    } else if (!dismissed) {
      tab.hidden = false;
    }

    tab.querySelector('[data-reward-open]').addEventListener('click', openModal);
    tab.querySelector('[data-reward-dismiss]').addEventListener('click', function () { tab.hidden = true; remember(); });
    modal.querySelectorAll('[data-reward-close]').forEach(function (btn) { btn.addEventListener('click', closeModal); });
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
  })();

  /* ---------- Modals (size chart) ---------- */
  document.querySelectorAll('[data-modal-open]').forEach(function (btn) {
    var modal = document.getElementById(btn.getAttribute('data-modal-open'));
    if (!modal) return;
    function close() { modal.hidden = true; btn.focus(); }
    btn.addEventListener('click', function () {
      modal.hidden = false;
      var x = modal.querySelector('[data-modal-close]');
      if (x) x.focus();
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-modal-close]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  });

  /* ---------- Size chart units (cm / in) ---------- */
  document.querySelectorAll('[data-size-chart]').forEach(function (chart) {
    var buttons = chart.querySelectorAll('[data-unit-btn]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var unit = btn.getAttribute('data-unit-btn');
        buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        chart.querySelectorAll('[data-unit]').forEach(function (table) { table.hidden = table.getAttribute('data-unit') !== unit; });
      });
    });
  });

  /* ---------- Smooth open/close for the product details rows ---------- */
  document.querySelectorAll('.details__item').forEach(function (item) {
    var summary = item.querySelector('summary');
    var body = item.querySelector('.details__body');
    if (!summary || !body || !body.animate || reduceMotion) return;
    var running = null;
    var timing = { duration: 320, easing: 'cubic-bezier(.4, 0, .2, 1)' };

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (running) running.cancel();
      if (item.open && !item.classList.contains('is-closing')) {
        item.classList.add('is-closing');
        running = body.animate({ height: [body.offsetHeight + 'px', '0px'], opacity: [1, 0] }, timing);
        running.onfinish = function () { item.open = false; item.classList.remove('is-closing'); running = null; };
        running.oncancel = function () { item.classList.remove('is-closing'); };
      } else {
        item.classList.remove('is-closing');
        item.open = true;
        running = body.animate({ height: ['0px', body.offsetHeight + 'px'], opacity: [0, 1] }, timing);
        running.onfinish = function () { running = null; };
      }
    });
  });

  /* ---------- Product page ---------- */
  (function product() {
    var root = document.querySelector('[data-product]');
    if (!root) return;

    var form = root.querySelector('#ProductForm');
    var idInput = root.querySelector('[data-variant-id]');
    var qtyInput = root.querySelector('[data-quantity]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var errorEl = root.querySelector('[data-error]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var stockNote = root.querySelector('[data-stock-note]');
    var track = root.querySelector('[data-gallery-track]');
    var dotsWrap = root.querySelector('[data-gallery-dots]');
    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-bundles] .bundle'));
    var addUrl = root.getAttribute('data-cart-add-url');
    var cartUrl = root.getAttribute('data-cart-url');
    var discount = parseFloat(root.getAttribute('data-discount')) || 0;

    var variants = Array.prototype.map.call(root.querySelectorAll('[data-variant]'), function (node) {
      return { id: node.getAttribute('data-variant'), options: node.getAttribute('data-options').split('|||'), d: node.dataset };
    });
    var current = null;

    /* Money: reuse the store's own format by swapping the number inside a sample. */
    var sample = root.getAttribute('data-money-sample') || '1,234.56';
    var sampleNum = (sample.match(/\d[\d.,'  ]*\d/) || ['1,234.56'])[0];
    var decMatch = sampleNum.match(/([.,])(\d{2})$/);
    var decSep = decMatch ? decMatch[1] : '';
    var thouMatch = sampleNum.match(/^1([^\d]?)23/);
    var thouSep = thouMatch ? thouMatch[1] : '';
    function money(cents) {
      var whole = decSep ? Math.floor(cents / 100) : Math.round(cents / 100);
      var text = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
      if (decSep && cents % 100) text += decSep + ('0' + (cents % 100)).slice(-2);
      return sample.replace(sampleNum, text);
    }

    function selectedOptions() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option]'), function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      if (!opts.length) return variants[0];
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }

    function selectedBundle() {
      return bundles.filter(function (b) { return b.classList.contains('is-selected'); })[0];
    }

    /* ----- Bundle slots: the extra pieces the customer picks ----- */
    var catalog = safe(function () {
      return JSON.parse(document.querySelector('[data-bundle-products]').textContent).filter(Boolean).map(function (p) {
        p.variants = p.variants.filter(Boolean);
        return p;
      }).filter(function (p) { return p.variants.length; });
    }) || [];
    var picker = document.querySelector('[data-bundle-picker]');
    var canPick = !!(picker && catalog.length);
    var slots = { two: [null], four: [null, null, null] };
    var activeSlot = null;

    function slotVariant(slot) {
      return slot.product.variants.filter(function (v) { return String(v.id) === String(slot.variantId); })[0] || slot.product.variants[0];
    }

    function renderSlots() {
      if (!canPick) return;
      bundles.forEach(function (b) {
        var kind = b.getAttribute('data-kind');
        var wrap = b.querySelector('[data-slots]');
        if (!wrap || !slots[kind]) return;
        wrap.textContent = '';
        slots[kind].forEach(function (slot, i) {
          var row = el('div', 'slot');
          var isFree = kind === 'four' && i === slots[kind].length - 1;
          if (!slot) {
            var add = el('button', 'slot__add');
            add.type = 'button';
            add.setAttribute('aria-label', 'Choose an item');
            add.appendChild(el('span', '', '+'));
            var choose = el('button', 'slot__btn', isFree ? 'Choose free item' : 'Choose');
            choose.type = 'button';
            [add, choose].forEach(function (btn) {
              btn.addEventListener('click', function (e) { e.preventDefault(); openPicker(kind, i); });
            });
            row.appendChild(add);
            row.appendChild(choose);
          } else {
            var thumb = el('span', 'bundle__thumb');
            if (slot.product.image) {
              var img = el('img');
              img.src = slot.product.image;
              img.alt = '';
              thumb.appendChild(img);
            }
            var pick = el('div', 'bundle__pick');
            if (isFree) pick.appendChild(el('span', 'slot__free', 'Free item'));
            pick.appendChild(el('span', 'bundle__name', slot.product.title));
            var line = el('div', 'bundle__pills');
            if (slot.product.variants.length > 1) {
              var select = el('select');
              select.setAttribute('aria-label', 'Options for ' + slot.product.title);
              slot.product.variants.forEach(function (v) {
                var opt = el('option', '', v.title);
                opt.value = v.id;
                if (String(v.id) === String(slot.variantId)) opt.selected = true;
                select.appendChild(opt);
              });
              select.addEventListener('change', function () { slot.variantId = select.value; updatePrices(); });
              line.appendChild(select);
            }
            var change = el('button', 'slot__change', 'Change');
            change.type = 'button';
            change.addEventListener('click', function (e) { e.preventDefault(); openPicker(kind, i); });
            line.appendChild(change);
            pick.appendChild(line);
            row.appendChild(thumb);
            row.appendChild(pick);
          }
          wrap.appendChild(row);
        });
      });
    }

    function openPicker(kind, index) {
      activeSlot = { kind: kind, index: index };
      picker.hidden = false;
      var first = picker.querySelector('[data-pick]');
      if (first) first.focus();
    }
    function closePicker() { picker.hidden = true; activeSlot = null; }

    if (canPick) {
      picker.addEventListener('click', function (e) {
        if (e.target === picker || e.target.closest('[data-picker-close]')) return closePicker();
        var item = e.target.closest('[data-pick]');
        if (!item || !activeSlot) return;
        var chosen = catalog.filter(function (p) { return String(p.id) === item.getAttribute('data-pick'); })[0];
        if (!chosen) return;
        slots[activeSlot.kind][activeSlot.index] = { product: chosen, variantId: chosen.variants[0].id };
        closePicker();
        errorEl.hidden = true;
        renderSlots();
        updatePrices();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !picker.hidden) closePicker(); });
    }

    function updatePrices() {
      if (!current) return;
      var base = parseInt(current.d.cents, 10) || 0;
      function priceOf(slot) { return slot ? slotVariant(slot).price : base; }

      bundles.forEach(function (b) {
        var kind = b.getAttribute('data-kind');
        var price = b.querySelector('[data-bundle-price]');
        var compare = b.querySelector('[data-bundle-compare]');
        var save = b.querySelector('[data-bundle-save]');
        var full, total;
        if (kind === 'one') {
          full = total = base;
        } else if (kind === 'two') {
          full = base + priceOf(slots.two[0]);
          total = Math.round(full * (100 - discount) / 100);
        } else {
          var all = [base].concat(slots.four.map(priceOf));
          full = all.reduce(function (a, n) { return a + n; }, 0);
          total = full - Math.min.apply(null, all);
        }
        if (price) price.textContent = money(total);
        if (compare) compare.textContent = money(full);
        if (save) save.textContent = money(full - total);
      });
    }

    function render(v) {
      current = v || null;
      if (!v) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = v.d.price;
      if (v.d.compare) { compareEl.textContent = v.d.compare; compareEl.hidden = false; } else { compareEl.hidden = true; }

      var available = v.d.available === 'true';
      addBtn.disabled = !available;
      addBtn.textContent = available ? 'Add to cart' : 'Sold out';

      var stock = parseInt(v.d.stock, 10);
      if (stockNote && !stockNote.hasAttribute('data-stock-always')) stockNote.hidden = !(stock > 0 && stock <= 5);

      updatePrices();

      /* Keep the pills inside bundle tiles in sync with the picked options. */
      var opts = v.options;
      root.querySelectorAll('[data-pill-select]').forEach(function (sel) { sel.value = opts[sel.getAttribute('data-pill-select')]; });
      root.querySelectorAll('[data-pill-swatch]').forEach(function (node) {
        var src = root.querySelector('[data-option="' + node.getAttribute('data-pill-swatch') + '"] input:checked + label');
        if (src) node.style.background = src.style.background;
      });

      if (v.d.media && track) {
        var item = track.querySelector('[data-media-id="' + v.d.media + '"]');
        if (item) track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      }

      safe(function () {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });
    }

    root.querySelectorAll('[data-option] input').forEach(function (input) {
      input.addEventListener('change', function () {
        var fs = input.closest('[data-option]');
        var label = fs.querySelector('[data-option-label]');
        if (label) label.textContent = input.value;
        errorEl.hidden = true;
        render(findVariant(selectedOptions()));
      });
    });

    bundles.forEach(function (b) {
      b.querySelector('input').addEventListener('change', function () {
        bundles.forEach(function (o) { o.classList.toggle('is-selected', o === b); });
        qtyInput.value = b.getAttribute('data-qty');
        errorEl.hidden = true;
      });
    });

    /* Dropdowns inside the bundle tiles drive the main colour and size pickers. */
    root.querySelectorAll('[data-pill-select]').forEach(function (sel) {
      sel.addEventListener('click', function (e) { e.stopPropagation(); });
      sel.addEventListener('change', function () {
        var fs = root.querySelector('[data-option="' + sel.getAttribute('data-pill-select') + '"]');
        if (!fs) return;
        var input = Array.prototype.filter.call(fs.querySelectorAll('input'), function (i) { return i.value === sel.value; })[0];
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    /* Grey "Choose ..." bar: select that bundle and open the picker. */
    root.querySelectorAll('[data-bundle-choose]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var tile = btn.closest('.bundle');
        var radio = tile.querySelector('input[name="bundle"]');
        if (!radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var kind = tile.getAttribute('data-kind');
        if (canPick && slots[kind]) {
          var empty = slots[kind].indexOf(null);
          openPicker(kind, empty === -1 ? 0 : empty);
        }
      });
    });

    /* Gallery dots */
    if (track && dotsWrap) {
      var dots = Array.prototype.slice.call(dotsWrap.children);
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); });
      });
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }, { passive: true });
    }

    /* What goes in the cart: the main piece plus whatever was picked for the bundle. */
    function cartItems() {
      var main = Number(idInput.value);
      var bundle = selectedBundle();
      var kind = bundle ? bundle.getAttribute('data-kind') : 'one';
      if (!bundle || kind === 'one') return [{ id: main, quantity: 1 }];
      if (!canPick) return [{ id: main, quantity: Number(bundle.getAttribute('data-qty')) }];
      if (slots[kind].some(function (s) { return !s; })) return null;
      return [{ id: main, quantity: 1 }].concat(slots[kind].map(function (s) {
        return { id: Number(slotVariant(s).id), quantity: 1 };
      }));
    }

    /* Add to cart without leaving the page */
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (addBtn.disabled) return;
      errorEl.hidden = true;

      var items = cartItems();
      if (!items) {
        errorEl.textContent = 'Choose the other items for your bundle first.';
        errorEl.hidden = false;
        return;
      }

      var label = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error(r.data.description || r.data.message || 'Could not add to cart.');
          addBtn.textContent = 'Added to cart ✓';
          return fetch(cartUrl, { headers: { 'Accept': 'application/json' } }).then(function (c) { return c.json(); });
        })
        .then(function (cart) {
          setCartCount(cart.item_count);
          setTimeout(function () { addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }, 2500);
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          addBtn.disabled = false;
          addBtn.textContent = label;
        });
    });

    /* Buy now: add the piece, then go straight to checkout */
    var buyBtn = root.querySelector('[data-buy-now]');
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        errorEl.hidden = true;
        var items = cartItems();
        if (!items) {
          errorEl.textContent = 'Choose the other items for your bundle first.';
          errorEl.hidden = false;
          return;
        }
        var label = buyBtn.textContent;
        buyBtn.disabled = true;
        buyBtn.textContent = 'One moment…';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (r) {
            if (!r.ok) throw new Error(r.data.description || r.data.message || 'Could not add to cart.');
            window.location.href = '/checkout';
          })
          .catch(function (err) {
            errorEl.textContent = err.message;
            errorEl.hidden = false;
            buyBtn.disabled = false;
            buyBtn.textContent = label;
          });
      });
    }

    /* Star rating under the price scrolls down to the Reviews section */
    var reviewsSection = document.getElementById('reviews');
    root.querySelectorAll('[data-reviews-link]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!reviewsSection) return;
        e.preventDefault();
        reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    renderSlots();
    render(findVariant(selectedOptions()));
  })();
  /* ---------- Collection: View all / Hoodies / Shirts / Pants ---------- */
  (function typeTabs() {
    var tabs = document.querySelector('[data-type-tabs]');
    if (!tabs) return;
    var cards = Array.prototype.slice.call(document.querySelectorAll('.collection .card[data-type]'));
    var count = document.querySelector('[data-type-count]');
    function show(type, push) {
      if (!tabs.querySelector('[data-type="' + type + '"]')) type = 'all';
      var n = 0;
      cards.forEach(function (card) {
        var on = type === 'all' || card.getAttribute('data-type') === type;
        card.hidden = !on;
        if (on) n++;
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-type-group]'), function (group) {
        group.hidden = !(type === 'all' || group.getAttribute('data-type-group') === type);
      });
      Array.prototype.forEach.call(tabs.querySelectorAll('a'), function (a) {
        var on = a.getAttribute('data-type') === type;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
      if (count) count.textContent = n + (n === 1 ? ' piece' : ' pieces');
      if (push && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        if (type === 'all') url.searchParams.delete('type'); else url.searchParams.set('type', type);
        history.replaceState(null, '', url);
      }
    }
    tabs.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-type]');
      if (!a) return;
      e.preventDefault();
      show(a.getAttribute('data-type'), true);
    });
    show(new URLSearchParams(window.location.search).get('type') || 'all', false);
  })();
  /* ---------- Collection: sort by popularity or price ---------- */
  (function sortSelect() {
    var select = document.querySelector('[data-sort]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      if (select.value) url.searchParams.set('sort_by', select.value); else url.searchParams.delete('sort_by');
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  })();
})();
